class Pedido
{
  idCliente = undefined;
  productosSeleccionados = [];

  constructor(obj = {}) {
    Object.assign(this, obj);
  }

  orden = undefined;
  direccionEntregaId = undefined;
  ordenCompraStr = undefined;
  tipoPedido = undefined;
  contactoCliente = undefined;
}

module.exports = Pedido;
